import { ArrowRightIcon, Button, Flex } from '@buffer-mono/popcorn'

import styles from './StepActions.module.css'

import type { JSX } from 'react'

interface StepActionsProps {
  onContinue: () => void
  disabled?: boolean
  controlsDisabled?: boolean
  loading?: boolean
  isSkippable?: boolean
  onSkip?: () => void
}

/**
 * @hardcoded "Continue" and "Skip" button labels are hardcoded strings. The GraphQL
 *   step type already has a `buttonText` field but survey steps ignore it.
 * @fix Wire `buttonText` through to survey steps and use it here. Remove the
 *   hardcoded strings.
 */
export function StepActions({
  onContinue,
  disabled,
  controlsDisabled,
  loading,
  isSkippable,
  onSkip,
}: StepActionsProps): JSX.Element {
  return (
    <Flex direction="column" gap="sm" align="center" className={styles.actions}>
      <Button
        size="large"
        className={styles.actionButton}
        onClick={onContinue}
        disabled={disabled || controlsDisabled}
        loading={loading}
        aria-busy={loading || undefined}
      >
        Continue <ArrowRightIcon />
      </Button>
      {isSkippable && (
        <Button
          variant="tertiary"
          size="large"
          onClick={onSkip}
          disabled={controlsDisabled || loading}
        >
          Skip
        </Button>
      )}
    </Flex>
  )
}
